<sb-dialog-activation>
  <chapter-step
    main-panel
    [title]="'🎉 ' + ('Your schedule is optimised and ready to go!' | translate)"
    [nextButtonLabel]="chapterCTAs?.primary?.label || 'Continue exploring' | translate"
    (next)="close({ action: 'primary' })"
  >
    <p class="m-0 text-base">
      {{
        "You're set up for smoother planning, fewer gaps, and shifts that just work. Need to make adjustments? Customise it further to fit your team's needs, or start inviting employees to get rolling. "
          | translate
      }}
      <a [href]="'schedule' | knowledgeBaseArticleLink" target="_blank" class="font-bold text-brand">
        {{ 'Learn more' | translate }}
      </a>
    </p>
  </chapter-step>
  <div
    class="size-full rounded-lg bg-cover bg-center bg-no-repeat lg:mr-12"
    aside-panel
    [ngStyle]="{
      backgroundImage: 'url(assets/images/onboarding/chapters/optimised-scheduling.jpg)'
    }"
  ></div>
</sb-dialog-activation>
